var _defs, _circle, _circle2, _circle3, _path, _path2, _path3, _path4, _polygon, _path5, _polyline, _polygon2, _path6, _polyline2, _polygon3, _path7, _polyline3, _polygon4, _path8, _polyline4, _polygon5, _path9, _polyline5, _polygon6, _rect, _path10, _rect2, _rect3, _path11, _rect4, _rect5, _path12, _rect6, _rect7, _path13, _rect8, _rect9, _path14, _rect10, _rect11, _rect12, _path15, _rect13, _rect14, _rect15, _path16, _rect16, _rect17, _rect18, _path17, _rect19, _rect20, _rect21, _path18, _rect22, _rect23, _path19, _rect24, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoPentagrammaWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512.29 512.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#00573d;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "LOGO PENTAGRAMMA-bordo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 256.14,
    cy: 256.14,
    r: 256.14
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 254.54,
    cy: 257.43,
    r: 241.82
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 256.14,
    cy: 256.15,
    r: 243.55
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M336,257.13a78.84,78.84,0,1,1-78.84-78.85A78.84,78.84,0,0,1,336,257.13Z",
    transform: "translate(-0.99 -0.99)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M257.13,355.15a98,98,0,1,1,98-98A98,98,0,0,1,257.13,355.15Zm0-190.86A92.84,92.84,0,1,0,350,257.13,92.85,92.85,0,0,0,257.13,164.29Z",
    transform: "translate(-0.99 -0.99)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M383.8,51c-59.88,0-76.58,54.7-127.82,54.7-58.15,0-67.94-53-128.4-54.7,0,0,57-38,128.4-38S383.8,51,383.8,51Z",
    transform: "translate(-0.99 -0.99)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M397.64,455.77c-91,0-87.52-49.51-138.76-49.51-61.61,0-56.43,50.09-143.94,50.09,0,0,69.67,44.91,141.06,44.91S397.64,455.77,397.64,455.77Z",
    transform: "translate(-0.99 -0.99)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "48.86 258.73 48.86 324.8 29.86 324.8 29.86 185.32 48.86 185.32 48.86 258.73"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.53,256.56a5.18,5.18,0,1,1-5.18-5.19,5.18,5.18,0,0,1,5.18,5.19Z",
    transform: "translate(-0.99 -0.99)"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "48.86 251.39 496.67 251.39 496.67 259.16 48.86 259.16"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "497.88 260.37 48.86 260.37 48.86 257.95 495.46 257.95 495.46 252.6 48.86 252.6 48.86 250.18 497.88 250.18 497.88 260.37"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.53,286.35a5.18,5.18,0,1,1-5.18-5.18h0A5.18,5.18,0,0,1,45.53,286.35Z",
    transform: "translate(-0.99 -0.99)"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "48.86 281.19 496.67 281.19 496.67 288.96 48.86 288.96"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "497.88 290.17 48.86 290.17 48.86 287.75 495.46 287.75 495.46 282.4 48.86 282.4 48.86 279.98 497.88 279.98 497.88 290.17"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.53,316.15a5.18,5.18,0,1,1-5.2-5.16h0A5.18,5.18,0,0,1,45.53,316.15Z",
    transform: "translate(-0.99 -0.99)"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "48.86 310.98 490.62 310.98 490.62 318.76 48.86 318.76"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "491.83 319.96 48.86 319.96 48.86 317.55 489.41 317.55 489.41 312.19 48.86 312.19 48.86 309.77 491.83 309.77 491.83 319.96"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.53,226.76a5.18,5.18,0,1,1-5.18-5.18h0A5.18,5.18,0,0,1,45.53,226.76Z",
    transform: "translate(-0.99 -0.99)"
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "48.86 221.59 496.67 221.59 496.67 229.37 48.86 229.37"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "497.88 230.58 48.86 230.58 48.86 228.16 495.46 228.16 495.46 222.8 48.86 222.8 48.86 220.39 497.88 220.39 497.88 230.58"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.53,197a5.18,5.18,0,1,1-5.18-5.18h0A5.18,5.18,0,0,1,45.53,197Z",
    transform: "translate(-0.99 -0.99)"
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "48.86 191.8 491.92 191.8 491.92 199.57 48.86 199.57"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "493.13 200.78 48.86 200.78 48.86 198.36 490.71 198.36 490.71 193.01 48.86 193.01 48.86 190.59 493.13 190.59 493.13 200.78"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 126.56,
    y: 191.8,
    width: 25.48,
    height: 105.37
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M154.24,299.36h-27.9V191.58h27.9ZM128.76,297h23.06V194H128.76Z",
    transform: "translate(-0.99 -0.99)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 139.08,
    y: 191.8,
    width: 12.96,
    height: 64.77
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 390.87,
    y: 211.23,
    width: 31.53,
    height: 99.75
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M424.64,313.18h-34V211h34Zm-31.53-2.42h29.11V213.43H393.07Z",
    transform: "translate(-0.99 -0.99)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 390.44,
    y: 212.09,
    width: 14.68,
    height: 58.73
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 183.59,
    y: 229.37,
    width: 31.52,
    height: 99.75
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M217.32,331.32h-34V229.15h34Zm-31.53-2.42H214.9V231.57H185.79Z",
    transform: "translate(-0.99 -0.99)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 183.59,
    y: 229.42,
    width: 14.25,
    height: 59.54
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 215.12,
    y: 199.57,
    width: 31.52,
    height: 110.55
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M248.84,312.32H214.9v-113h33.94Zm-31.52-2.42h29.1V201.77h-29.1Z",
    transform: "translate(-0.99 -0.99)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 232.39,
    y: 199.62,
    width: 14.25,
    height: 66.02
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 152.04,
    y: 181.46,
    width: 31.52,
    height: 99.75
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M185.77,283.41h-34V181.24h34ZM154.24,281h29.11V183.66H154.24Z",
    transform: "translate(-0.99 -0.99)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 152.04,
    y: 181.51,
    width: 12.12,
    height: 59.54
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 171.33,
    y: 181.51,
    width: 12.12,
    height: 59.54
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 277.7,
    y: 199.21,
    width: 31.52,
    height: 94.48
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M311.4,295.85H277.52V199H311.4Zm-31.53-2.35H309V201.38H279.87Z",
    transform: "translate(-0.99 -0.99)"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 277.7,
    y: 199.26,
    width: 12.12,
    height: 56.39
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 297,
    y: 199.26,
    width: 12.12,
    height: 56.39
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 246.18,
    y: 242.35,
    width: 31.52,
    height: 99.75
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M279.9,344.3H246V242.13H279.9Zm-31.52-2.42h29.11V244.54H248.38Z",
    transform: "translate(-0.99 -0.99)"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 246.18,
    y: 242.4,
    width: 12.12,
    height: 59.54
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 265.47,
    y: 242.4,
    width: 12.12,
    height: 59.54
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 362.34,
    y: 181.46,
    width: 31.52,
    height: 99.75
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M396.07,283.41H362.13V181.24h33.94ZM364.54,281h29.1V183.66h-29.1Z",
    transform: "translate(-0.99 -0.99)"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 362.34,
    y: 181.51,
    width: 12.12,
    height: 59.54
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 381.64,
    y: 181.51,
    width: 12.12,
    height: 59.54
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 336.43,
    y: 164.62,
    width: 25.91,
    height: 104.5
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M364.54,271.32H336.22V164.4h28.32Zm-25.9-2.42h23.5V166.82h-23.5Z",
    transform: "translate(-0.99 -0.99)"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 336.43,
    y: 164.67,
    width: 12.12,
    height: 59.54
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 309.66,
    y: 199.64,
    width: 27.66,
    height: 94.5
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M339.42,296.23H309.55v-96.7h29.87ZM311.76,294h25.45v-92.3H311.76Z",
    transform: "translate(-0.99 -0.99)"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 309.66,
    y: 199.69,
    width: 10.64,
    height: 56.4
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M128.77,368.19h4.33v27.12h-4.33Z",
    transform: "translate(-0.99 -0.99)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M138,368.19h4.34v23.48h10.48v3.64H138Z",
    transform: "translate(-0.99 -0.99)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M166.81,368.19h8.59c5.2,0,7.48,3.26,7.48,7.9,0,4.86-2.85,8-7.94,8h-3.8v11.2h-4.33Zm4.33,12.65h3.08c2.32,0,4.33-1.26,4.33-4.68,0-2.92-1.18-4.71-4.63-4.71h-2.78Z",
    transform: "translate(-0.99 -0.99)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M187,368.19h14.69v3.64H191.28v7.53H201V383h-9.73v8.67h10.64v3.64h-15Z",
    transform: "translate(-0.99 -0.99)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M206.37,368.19h5.27l7.86,20.21h.14V368.19h4.1v27.12h-5.28l-7.86-20.74h-.08v20.74h-4.1Z",
    transform: "translate(-0.99 -0.99)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M233.77,371.83h-6.46v-3.64h17.13v3.64H238.1v23.48h-4.33Z",
    transform: "translate(-0.99 -0.99)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M251.1,368.19h5.54l7.14,27.12h-4.52l-1.62-6.65h-8l-1.75,6.65h-4.52Zm5.77,17-3.12-13.38h-.11l-3.23,13.38Z",
    transform: "translate(-0.99 -0.99)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M280.24,392.16h-.08c-1.17,2.51-2.73,3.69-5.92,3.69-5.93,0-8.06-4.41-8.06-14.1s2.74-14.1,9-14.1c6.8,0,7.94,5.36,7.94,7.83v.5H279v-.65c0-2-.83-4.41-3.8-4.41s-4.71,2.05-4.71,10.72,1.45,10.94,4.37,10.94c3.31,0,4.52-2.36,4.52-8.28h-4.55V381h8.66v14.28h-3.26Z",
    transform: "translate(-0.99 -0.99)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M288.37,368.19H298c3.8,0,6.88,1.9,6.88,7,0,3.49-1.56,6.19-4.53,6.65v.07c2.7.27,4.11,1.75,4.26,5.55,0,1.75.08,3.87.15,5.51a2.79,2.79,0,0,0,1.29,2.35h-4.9a4.5,4.5,0,0,1-.72-2.39c-.15-1.63-.11-3.15-.19-5.13-.08-3-1-4.25-3.95-4.25h-3.53v11.77h-4.34Zm7.79,12.08c2.78,0,4.33-1.67,4.33-4.41s-1.25-4.41-4.1-4.41h-3.68v8.82Z",
    transform: "translate(-0.99 -0.99)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M315.05,368.19h5.59l7.14,27.12h-4.52l-1.67-6.65h-8l-1.74,6.65h-4.51Zm5.77,17-3.11-13.38h-.07l-3.23,13.38Z",
    transform: "translate(-0.99 -0.99)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M330.78,368.19h6.77l4.78,20.09h.08l4.71-20.09h6.61v27.12h-4.09V372.75h-.08l-5.47,22.56h-3.65L335,372.75h-.07v22.56h-4.11Z",
    transform: "translate(-0.99 -0.99)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M359.36,368.19h6.76l4.79,20.09H371l4.72-20.09h6.61v27.12H378.2V372.75h-.07l-5.49,22.56H369l-5.47-22.56h-.08v22.56h-4.1Z",
    transform: "translate(-0.99 -0.99)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M393.06,368.19h5.58l7.14,27.12h-4.52l-1.67-6.65h-7.95l-1.75,6.65h-4.52Zm5.78,17-3.12-13.38h-.08l-3.23,13.38Z",
    transform: "translate(-0.99 -0.99)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M257.13,505C120.24,505,9.26,394,9.27,257.11A247.84,247.84,0,0,1,81.86,81.86c96.56-97,253.5-97.44,350.54-.88s97.44,253.5.88,350.54l-.88.88A246.27,246.27,0,0,1,257.13,505Zm0-487.1C125,17.89,17.9,125,17.89,257.11A239.25,239.25,0,0,0,88,426.29c92.62,94.22,244.09,95.52,338.31,2.9s95.52-244.09,2.9-338.31c-1-1-1.92-1.94-2.89-2.89A237.64,237.64,0,0,0,257.13,17.9Z",
    transform: "translate(-0.99 -0.99)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPentagrammaWhite);
export default __webpack_public_path__ + "static/media/logo-pentagramma-white.3c94055d6cd14e75688110764938f6df.svg";
export { ForwardRef as ReactComponent };